<template>
  <div class="f-homePage">
    <images-carousel></images-carousel>
    <!--<carta-header-accordion class="top-spacing"></carta-header-accordion>-->
    <CartaHeader class="top-spacing"></CartaHeader>

    <about-us class="top-spacing"></about-us>
    <statistics class="top-spacing"></statistics>
<!--    <contest class="top-spacing"></contest>-->
    <events class="top-spacing"></events>
    <news class="top-spacing"></news>
    <social-wall class="top-spacing"></social-wall>
  </div>
</template>

<script>
  import CartaHeader from './cartaAlpFoodWay/CartaHeader'
  import Statistics from './Statistics'
  import News from './News'
  import Events from './Events'
  import SocialWall from './SocialWall'
  import ImagesCarousel from './ImagesCarousel'
  import CountdownPanel from '../../countdownComponents/CountdownPanel'
  import AboutUs from './AboutUs'
  import CartaHeaderAccordion from './cartaAlpFoodWay/CartaHeaderAccordion'
  import Contest from './Contest'

export default {
    name: 'HomePage',
    components: {
      Contest,
      CartaHeaderAccordion,
      AboutUs,
      ImagesCarousel,
      SocialWall,
      Events,
      News,
      Statistics,
      CartaHeader,
      CountdownPanel
    },
    props: {
      default: {
        type: Object
      },
      preview: {
        default: false,
        type: Boolean
      }
    },
    created: function () {
      if ((!this.$store.getters.isPreviewModeValue) && this.isPastRelaseDate && this.$PATH_NAME !== 'http://localhost:8080/') {
        this.$store.commit('setCurrentView', CountdownPanel)
        this.$router.push('/countdown')
      } else {
        this.$store.commit('setCurrentView', this.default)
      }

      if (this.preview) {
        this.$store.commit('setIsPreviewMode', true)
        this.$router.push('/')
        console.log('Preview mode: ' + this.$store.getters.isPreviewModeValue)
      }
    }
  }
</script>

<style>

  .clickable {
    cursor: pointer;
  }

  /*.side-border {*/
  /*border-right: 1px solid grey;*/
  /*}*/

  .counterStyle {
    font-weight: bold;
    font-size: 2em;
    margin-bottom: 0;
    padding-bottom: 1%;
    color: #c41c21;
  }

  .counterSubStyle {
    padding-left: 20%;
    padding-right: 20%;
    font-size: 1.4em;
    padding-bottom: 2%;
    color: grey;
    font-weight: bold;
  }

  .icon {
    cursor: pointer;
    height: 6em;
    background-repeat: no-repeat;
    background-size: contain;
    /*vertical-align: text-bottom;*/
    /*display: table;*/
    margin: 0 auto 3%;
    width: 100px;

    display: inline-block;
    vertical-align: middle;
    -webkit-transform: translateZ(0);
    transform: translateZ(0);
    box-shadow: 0 0 1px rgba(0, 0, 0, 0);
    -webkit-backface-visibility: hidden;
    backface-visibility: hidden;
    -moz-osx-font-smoothing: grayscale;
    -webkit-transition-duration: 0.3s;
    transition-duration: 0.3s;
    -webkit-transition-property: transform;
    transition-property: transform;
  }

  .icon:hover, .icon:focus, .icon:active {
    -webkit-transform: scale(1.1);
    transform: scale(1.1);
  }

  .post-container {
    margin: 0 auto;
  }
</style>



// WEBPACK FOOTER //
// src/components/pagesComponents/homePageComponents/HomePage.vue